var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuropeDirect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.108,
    height: 49.252,
    viewBox: "0 0 88.108 49.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.108,
    height: 49.252,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88.107,
    height: 49.252,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 41.268,
    height: 27.512,
    transform: "translate(0 21.603)",
    fill: "#039"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.754,27.6l.871-.635.871.635-.332-1.028.885-.635H20.958l-.333-1.04-.334,1.041H19.2l.883.635Z",
    fill: "#fc0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.248,28.808l.871-.635.87.635-.331-1.028.884-.635h-1.09L16.118,26.1l-.333,1.042H14.7l.884.635Z",
    fill: "#fc0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.822,29.408l-.334,1.042H11.4l.884.636-.332,1.027.871-.635.871.635-.332-1.027.884-.636H13.156Z",
    fill: "#fc0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.612,35.978l.87.635-.331-1.027.884-.636H11.946l-.334-1.041-.334,1.044-1.09,0,.885.636-.332,1.027Z",
    fill: "#fc0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.155,39.465l-.334-1.041-.333,1.042H11.4l.884.635-.331,1.028.87-.636.871.636L13.361,40.1l.884-.635Z",
    fill: "#fc0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.459,42.768l-.334-1.04-.333,1.041H14.7l.884.635-.331,1.028.871-.635.87.635L16.665,43.4l.884-.635Z",
    fill: "#fc0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.959,43.965l-.334-1.041-.333,1.042H19.2l.884.635-.331,1.028.871-.635.87.635L21.165,44.6l.884-.635Z",
    fill: "#fc0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.46,42.768l-.333-1.04-.334,1.041H23.7l.883.635-.331,1.028.871-.635.871.635L25.666,43.4l.884-.635Z",
    fill: "#fc0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.765,39.465l-.334-1.041L28.1,39.466h-1.09l.885.635-.332,1.028.871-.636.871.636L28.97,40.1l.884-.635Z",
    fill: "#fc0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.051,34.938h-1.09L29.627,33.9l-.334,1.042H28.2l.885.635L28.757,36.6l.87-.636.87.636-.33-1.028Z",
    fill: "#fc0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.56,32.1l.871-.635.871.635-.332-1.028.884-.634H28.765L28.431,29.4,28.1,30.438H27.008l.884.634Z",
    fill: "#fc0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.14,26.1l-.333,1.042-1.09,0,.883.637-.331,1.027.872-.636.87.636-.331-1.027.884-.637H25.473Z",
    fill: "#fc0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.879,28.888h-2.79v1.8h3.116v1.406H48.379V24.512h4.669v1.406H50.089v1.575h2.79Z",
    fill: "#039"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.085,24.512v4.353c0,1.317.506,1.98,1.372,1.98.9,0,1.4-.63,1.4-1.98V24.512h1.71v4.252c0,2.34-1.181,3.454-3.161,3.454-1.912,0-3.026-1.069-3.026-3.476v-4.23Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.045,24.614a14.949,14.949,0,0,1,2.284-.158,3.871,3.871,0,0,1,2.452.6,1.924,1.924,0,0,1,.709,1.6,2.008,2.008,0,0,1-1.339,1.856v.034a1.888,1.888,0,0,1,1.013,1.406c.236.866.461,1.856.607,2.148H66.016a10.138,10.138,0,0,1-.517-1.766c-.214-.956-.54-1.2-1.249-1.215h-.506v2.981h-1.7Zm1.7,3.262h.675c.855,0,1.361-.427,1.361-1.091,0-.686-.472-1.046-1.26-1.046a3.4,3.4,0,0,0-.776.056Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.611,28.224c0,2.5-1.5,3.993-3.723,3.993a3.544,3.544,0,0,1-3.566-3.869,3.676,3.676,0,0,1,3.69-3.971,3.537,3.537,0,0,1,3.6,3.847m-5.478.09c0,1.5.7,2.542,1.845,2.542s1.822-1.1,1.822-2.576c0-1.372-.641-2.542-1.822-2.542s-1.845,1.1-1.845,2.576",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.735,24.614a14.036,14.036,0,0,1,2.318-.158,3.636,3.636,0,0,1,2.317.608,2.182,2.182,0,0,1,.81,1.755,2.359,2.359,0,0,1-.7,1.8,3.568,3.568,0,0,1-2.463.8,2.921,2.921,0,0,1-.585-.045v2.722h-1.7Zm1.7,3.442a2.541,2.541,0,0,0,.574.045c.911,0,1.473-.461,1.473-1.226,0-.7-.483-1.114-1.35-1.114a3.108,3.108,0,0,0-.7.056Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.781,28.888h-2.79v1.8h3.116v1.406H83.281V24.512H87.95v1.406H84.991v1.575h2.79Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.368,37.513a15.166,15.166,0,0,1,2.306-.168,4.947,4.947,0,0,1,3.116.809,3.354,3.354,0,0,1,1.283,2.858,3.878,3.878,0,0,1-1.249,3.071,5.483,5.483,0,0,1-3.51.978,14.776,14.776,0,0,1-1.946-.112Zm1.71,6.176a3.191,3.191,0,0,0,.6.034,2.362,2.362,0,0,0,2.588-2.655,2.191,2.191,0,0,0-2.408-2.407,3.706,3.706,0,0,0-.776.067Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71,
    height: 7.582,
    transform: "translate(56.208 37.4)",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4,37.5a14.949,14.949,0,0,1,2.284-.158,3.864,3.864,0,0,1,2.452.6,1.924,1.924,0,0,1,.709,1.6,2.008,2.008,0,0,1-1.339,1.856v.034a1.892,1.892,0,0,1,1.013,1.406c.236.866.461,1.856.607,2.148H63.373a10.2,10.2,0,0,1-.517-1.766c-.214-.956-.54-1.2-1.249-1.214H61.1v2.98H59.4Zm1.7,3.262h.675c.855,0,1.361-.427,1.361-1.091,0-.686-.472-1.046-1.26-1.046a3.4,3.4,0,0,0-.776.056Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.583,41.776h-2.79v1.8h3.116v1.406H66.083V37.4h4.669v1.406H67.793v1.575h2.79Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.636,44.78a5.041,5.041,0,0,1-1.935.326,3.614,3.614,0,0,1-3.971-3.8,3.857,3.857,0,0,1,4.14-4.016,4.285,4.285,0,0,1,1.867.338l-.36,1.35a3.6,3.6,0,0,0-1.44-.282A2.278,2.278,0,0,0,73.53,41.2a2.261,2.261,0,0,0,2.419,2.475,4.092,4.092,0,0,0,1.44-.248Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4,38.841H78.355V37.4h5.827v1.44h-2.07v6.142H80.4Z",
    fill: "#039"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropeDirect);
export default __webpack_public_path__ + "static/media/europe-direct.9505144eb014f57e3a0ddf498bde8747.svg";
export { ForwardRef as ReactComponent };